var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider"},[_c('div',{class:['slide', _vm.slideUp]},[_c('img',{attrs:{"src":['#000', '#000000'].includes(_vm.template.textColor) ? '/img/TN_PRETO.png' : '/img/TN_BRANCO.png',"width":"400","alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }